import React from 'react';
import TabLinkUI from '../../../widgets/output/TabLinkUI';

const MonitoringIntelligencePageNavUI = ({ context, page }) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI
        label='Summary'
        to={`/su/monitoringIntelligence/summary`}
        active={page === 'monitoringIntelligence_summary'}
      />
      <TabLinkUI
        label='Non Retail'
        to={`/su/monitoringIntelligence`}
        active={page === 'monitoringIntelligence'}
      />
      <TabLinkUI
        label='Retail'
        to={`/su/monitoringIntelligence/retail`}
        active={page === 'monitoringIntelligence_retail'}
      />
    </div>
    <div className='g_m_top_50' />
  </div>

export default MonitoringIntelligencePageNavUI
